import type { PageBlockType } from '../../api/types'
import {
  editorialGridDefinition,
  heroOverlayDefinition,
  livewireCalloutDefinition,
  rankedListDefinition,
  unrankedListDefinition,
  sectionDividerDefinition,
  spacerDefinition,
  inlineFeatureDefinition,
  featureWithRailDefinition,
  storyRowDefinition,
} from './definitions'
import type { PageBlockDefinition } from './definition-types'

export type {
  EditorFieldDefinition,
  EditorFieldType,
  PageBlockDefinition,
  SlotDefinition,
} from './definition-types'

export const PAGE_BLOCK_REGISTRY: Record<PageBlockType, PageBlockDefinition> = {
  'story-row': storyRowDefinition,
  'ranked-list': rankedListDefinition,
  'unranked-list': unrankedListDefinition,
  'inline-feature': inlineFeatureDefinition,
  'feature-with-rail': featureWithRailDefinition,
  'hero-overlay': heroOverlayDefinition,
  'editorial-grid': editorialGridDefinition,
  'livewire-callout': livewireCalloutDefinition,
  'section-divider': sectionDividerDefinition,
  'spacer': spacerDefinition,
}
